import { Button, Form, Input, Upload, UploadProps } from "antd";
import React, { KeyboardEvent, useState } from "react";
import { ArrowRightOutlined, PaperClipOutlined } from "@ant-design/icons";
import { FileNameRC } from "../FileNameRC/FileNameRC";
import { FileNameType, IsendToMessage } from "../Types/Type";
import { validateFile } from "../../../utils/utilities/validateFile";

import classes from "./ChatFooter.module.css";

/**
 * Компонент формы отправки сообщения в чате.
 *
 * @param {{ sendToMessage: (message: { chatInputText?: string; file?: { file: File }; }) => void; delliteFile: () => boolean; }} props
 * @property {function({ chatInputText?: string; file?: { file: File }; }): void} sendToMessage - Функция отправки сообщения
 * @property {function(): boolean} delliteFile - Функция удаления файла
 */
export function ChatFooter(props: IsendToMessage): JSX.Element {
  const { sendToMessage, delliteFile } = props;
  const [fileName, setFileName] = useState<FileNameType>(null);
  const [form] = Form.useForm();
  const uploadFileData: UploadProps = {
    showUploadList: false,
    beforeUpload: () => false,
  };

  function deleteFileButton(): void {
    const result = delliteFile();
    if (result) {
      setFileName(null);
      form.resetFields(["file"]);
    }
  }

  function handleFieldsChange(): void | undefined {
    const fieldValues = form.getFieldsValue();
    const fileFieldValue = fieldValues["file"];
    if (fileFieldValue && fileFieldValue.file) {
      const fileName = fileFieldValue.file.name;
      const { isValidate, error } = validateFile(fileFieldValue.file);

      if (isValidate) {
        setFileName({
          typeFile: true,
          message: fileName,
        });
      } else if (error) {
        setFileName({
          typeFile: false,
          message: error,
        });
        form.resetFields(["file"]);
      }
    }
  }

  function onFinish(message: {
    chatInputText?: string;
    file?: { file: File };
  }): void {
    if (
      (message?.chatInputText !== undefined &&
        message?.chatInputText.trim().length !== 0) ||
      message?.file !== undefined
    ) {
      if (message?.chatInputText?.trim().length === 0) {
        sendToMessage({
          file: message.file,
        });
      } else {
        sendToMessage(message);
      }
      setFileName(null);
    }
    form.resetFields();
  }

  function handleKeyUp(event: KeyboardEvent<HTMLTextAreaElement>): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      form.submit();
    }
  }

  return (
    <div className={classes.chatFooter}>
      <FileNameRC fileName={fileName} deleteFileButton={deleteFileButton} />
      <Form
        form={form}
        onFieldsChange={handleFieldsChange}
        onFinish={onFinish}
        className={classes.chatFooter__form}
        name="form_FooterChat"
      >
        <Form.Item className={classes.chatFooter__uploadButton} name="file">
          <Upload
            showUploadList={false}
            {...uploadFileData}
            action={undefined}
            fileList={[]}
          >
            <PaperClipOutlined className={classes.chatFooter__uploadIcon} />
          </Upload>
        </Form.Item>
        <Form.Item
          className={classes.chatFooter__fieldWrapper}
          name="chatInputText"
        >
          <Input.TextArea
            className={classes.chatFooter__field}
            placeholder="Введите сообщение"
            onKeyDown={handleKeyUp}
            rows={1}
          />
        </Form.Item>
        <Button
          className={classes.chatFooter__submitButton}
          onClick={() => form.submit()}
        >
          <ArrowRightOutlined />
        </Button>
      </Form>
    </div>
  );
}
